import { render, staticRenderFns } from "./questionGap.vue?vue&type=template&id=f978964e&scoped=true&"
import script from "./questionGap.vue?vue&type=script&lang=js&"
export * from "./questionGap.vue?vue&type=script&lang=js&"
import style0 from "./questionGap.vue?vue&type=style&index=0&id=f978964e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f978964e",
  null
  
)

export default component.exports